import React from 'react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { MDXProvider } from '@theme-ui/mdx'
import components from '@components/Mdx'
// import { searchStringToObject } from 'serialize-query-params';

export const PostBody = ({ body, location }) => {
  // console.log('Post Body location: ', location)
  // console.log('Post Body Type: ', typeof body)
  // console.log('Post Body: ', body)
  const locationStr = `var _location = ${JSON.stringify(location)};\n`
  // console.log('Post Body locationStr: ', locationStr)
  const newBody = locationStr.concat(body)
  // console.log('Post Body newBody: ', newBody)

  // https://www.gatsbyjs.com/plugins/gatsby-plugin-use-query-params/?=gatsby-plugin-use-query-params
  // https://github.com/pbeshai/use-query-params/tree/master/packages/serialize-query-params
  // const obj = searchStringToObject(location.search);
  // console.log('Post Body searchStringToObject: ', obj)

  return (
    <MDXProvider components={components}>
      <MDXRenderer data={"TEST-PROPS"}>{newBody}</MDXRenderer>
    </MDXProvider>
  )
}
